import React, { useState } from "react";
import { getUnities } from "../../../slices/productSlice";
import { createUnity } from "../../../api/inventoryApi";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";


const AddUnit = () => {
    const [unityName, setUnityName] = useState("");
    const [status, setStatus] = useState(true);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const showAlert = (config) => {
        Swal.fire({
            ...config,
            icon: config.type || "success",
            confirmButtonText: "OK",
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!unityName.trim()) {
            showAlert({
                text: "Veuillez saisir un nom d'unités.",
                type: "warning",
            });
            return;
        }

        setLoading(true);
        try {
            const response = await createUnity({
                name: unityName,
                unityStatus: status,
            });

            if (response.status === 201) {
                showAlert({
                    text: "Unité créée avec succès !",
                    type: "success",
                });
                setUnityName("");
                setStatus(true);
                const newUnity = response.data.unities;
                dispatch(getUnities(newUnity));
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Erreur lors de la création.";
            showAlert({
                text: errorMessage,
                type: "error",
            });
            // alert(error);
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div>
            {/* Add Unit */}
            <div className="modal fade" id="add-units">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Créer une Unité</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label">Nom de l&apos;unité de mesure</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={unityName}
                                                onChange={(e) => setUnityName(e.target.value)}
                                                placeholder="Entrez le nom de l'unité"
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                                <span className="status-label">Statut</span>
                                                <input
                                                    type="checkbox"
                                                    id="status"
                                                    checked={status}
                                                    onChange={(e) => setStatus(e.target.checked)}
                                                    className="check"
                                                />
                                                <label htmlFor="status" className="checktoggle"></label>
                                            </div>
                                        </div>
                                        <div className="modal-footer-btn">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                            >
                                                Annuler
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-submit"
                                                disabled={!unityName || loading}
                                            >
                                                {loading ? "Chargement..." : "Créer"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Unit */}
        </div>
    )
}

export default AddUnit
